import { PROFILE__SET_PROFILE } from './types';

const profileState = {
    attributes: {},
    company_id: '',
    company_name: '',
    company_url: '',
    country: '',
    email: {},
    external_id: '',
    family_name: '',
    given_name: '',
    initials: '',
    locale: '',
    name: '',
    nickname: '',
    permissions: {},
    person_id: '',
    preferred_username: '',
    recovery_methods_set: false,
    recovery_methods_url: '',
    s_hash: '',
    sid: '',
    sub: ''
};

export const profileReducer = ( state = profileState, action ) => {
    switch ( action.type ) {
        case PROFILE__SET_PROFILE:
            return {
                ...state,
                ...action.profile
            };
        default:
            return state;
    }
};
